import { render, staticRenderFns } from "./Studios.vue?vue&type=template&id=89130b0c&scoped=true"
import script from "./Studios.vue?vue&type=script&lang=js"
export * from "./Studios.vue?vue&type=script&lang=js"
import style0 from "./Studios.vue?vue&type=style&index=0&id=89130b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89130b0c",
  null
  
)

export default component.exports